import { removeClassFromAllElements } from './helpers';

const TAB_ELEMENT = {
  container: '.js-tabs',
  tabLink: '.js-tab-link',
  tabContent: '.js-tab-content',
  showClass: 'is-show',
  activeClass: 'is-active',
};

/**
 * показавает контент активного таба
 * @param allTabContent {NodeList} - все контентные части таба
 * @param id {String} - активный id таба
 */
function showActiveContent(allTabContent, id) {
    allTabContent.forEach((el) => {
       if (el.dataset.id === id) {
           // eslint-disable-next-line no-param-reassign
           el.style.display = 'block';
       }
    });
}

/**
 * скрытие контента для всех табов
 * @param allTabContent {NodeList} - все контентные части таба
 */
function hideAllTabContent(allTabContent) {
    allTabContent.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.style.display = 'none';
    });
}

/**
 * определение активного id для таба
 * @param tabLink {HTMLElement} - активный таб
 * @returns {string}
 */
function getActiveId(tabLink) {
    return tabLink.dataset.href;
}

export default function tabs() {
    const tabsContainer = document.querySelectorAll(TAB_ELEMENT.container);
    if (!tabsContainer) { return false; }

    tabsContainer.forEach((container) => {
        const tabLinks = container.querySelectorAll(TAB_ELEMENT.tabLink);
        const allTabContent = container.querySelectorAll(TAB_ELEMENT.tabContent);
        let id = getActiveId(tabLinks[0]);
        hideAllTabContent(allTabContent);
        showActiveContent(allTabContent, id);

        tabLinks.forEach((tabLink) => {
            tabLink.addEventListener('click', () => {
                if (tabLink.classList.contains(TAB_ELEMENT.activeClass)) { return false; }
                id = getActiveId(tabLink);
                hideAllTabContent(allTabContent);
                removeClassFromAllElements(tabLinks, TAB_ELEMENT.activeClass);
                showActiveContent(allTabContent, id);
                tabLink.classList.add(TAB_ELEMENT.activeClass);
            });
        });
    });
}
